<style>
#taskCardModal .v--modal-box.v--modal {
  min-height: 360px !important;
  min-width: 550px !important;
}
#taskCardModal .values__list {
  display: flex;
}
#taskCardModal .values__list,
.list__container {
  width: 100%;
}
#start .v-subheader {
  padding-left: 0;
  color: #2a579a;
  font-weight: 700;
}
#start .list__container--el {
  display: flex;
  justify-content: space-between;
}
#start .modal__container {
  padding-bottom: 0px;
}
.list__container--el > span {
  margin-left: 10px;
}
#timeline {
  max-width: 100%;
}
.btn__subheader {
  opacity: 0.4;
  line-height: 40px;
  transition: all 0.2s;
}
.btn__subheader:hover {
  opacity: 1;
}
.first-subheader {
  height: 16px;
}
#taskCardModal .list__container--edit {
  display: flex;
  align-items: center;
}
#taskCardModal .card__edit--span {
  margin-bottom: 5px;
}
#taskCardModal .card__edit--input {
  text-align: right;
  border-bottom: 1px solid lightgray;
}
#taskCardModal .v-tabs__div:not(:last-child) {
  padding-right: 5px;
}
#taskCardModal .v-tabs__div {
  background-image: linear-gradient(
      to bottom,
      rgba(42, 87, 154, 1) 0%,
      rgba(42, 87, 154, 1) 100%
    ),
    linear-gradient(
      to bottom,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 100%
    );
  background-clip: content-box, padding-box;
}
#taskCardModal .v-subheader {
  font-size: 14px !important;
  color: #000 !important;
  font-weight: 600 !important;
}
#taskCardModal .btn--materials {
  position: relative;
  top: -5px;
  font-size: 25px;
}
#taskCardModal .profileList {
  width: 100%;
  margin-bottom: 10px;
  padding: 0px;
  border: 1px solid black;
}
#taskCardModal .v-list__tile__title {
  text-align: center;
}
#taskCardModal .geometry__wrapper span {
  text-transform: uppercase;
}
#taskCardModal .geometry__wrapper .flex {
  align-items: center;
  display: flex;
}
/* .profileList {
  padding: 0px;
  border: 1px solid black;
} */
#taskCardModal .border--left {
  border-left: 1px solid black;
}
#taskCardModal .list__el--bolder {
  font-weight: bold;
}
#taskCardModal .v-list__tile {
  padding: 0;
}
#taskCardModal .btn__materials--wrapper {
  display: flex;
  justify-content: flex-end;
}
#taskCardModal .list--el--bold {
  font-weight: bold;
  background-color: lightgray;
}
#taskCardModal .geometry-panel__add-btn,
#taskCardModal .geometry-panel__delete-btn,
#taskCardModal .geometry-panel__zoom-btn {
  line-height: 16px;
  padding-right: 0;
  padding-left: 0;
}
#taskCardModal .checkbox--photo {
  top: 3px;
  position: relative;
  margin-right: 2px;
}
#taskCardModal .v-select__selections {
  display: contents;
}
#taskCardModal .v-select__selection {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: block;
}
#taskCardModal .datepicker--hide {
  pointer-events: none;
}
</style>

<template>
  <Modal
    modalName="taskCardModal"
    :title="cardTitle"
    :editing="editing"
    @editingStart="startEditing()"
    @editingSave="saveEditing()"
    @editingCancel="cancelEditing()"
    @opened="updateList(), getDicts(), getUsers()"
    :module="module"
    @closed="closed"
    :isNewObject="isNewTask"
    :hideButtons__right="!isNewTask"
    @saved="saveTask()"
    :zoom__left="true"
    :print__left="true"
    @zoom="zoomToGeom()"
    @print="printReport()"
  >
    <v-tabs
      color="#2a579a"
      dark
      centered
      grow
      active-class="tab--active"
      :hide-slider="true"
      height="35"
    >
      <v-tab>ZADANIE</v-tab>
      <v-tab-item>
        <v-form v-model="valid" ref="form">
          <v-layout row wrap>
            <v-flex xs12>
              <v-subheader>PODSTAWOWE INFORMACJE O ZADANIU</v-subheader>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5>
              <!-- <v-btn @click="aa">
              aa
            </v-btn> -->
              <v-select
                :items="task_type"
                no-data-text="Brak typów zadania"
                v-model="taskData.task_type"
                :readonly="!editing"
                label="Typ zadania"
                :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                :rules="required"
              >
              </v-select>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-select
                :items="status"
                no-data-text="Brak statusów"
                v-model="taskData.status"
                :readonly="!editing"
                label="Status"
                :rules="required"
                :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5>
              <v-select
                :items="net_type"
                no-data-text="Brak typów sieci"
                v-model="taskData.net_type"
                :readonly="!editing"
                label="Typ sieci"
                :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
              ></v-select>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-select
                :items="priority"
                no-data-text="Brak priorytetów"
                v-model="taskData.priority"
                :readonly="!editing"
                :rules="required"
                label="Priorytet"
                :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout v-if="!isNewTask" row wrap>
            <v-flex xs5>
              <v-text-field
                v-model="formattedCreatedTime"
                label="Data utworzenia zadania"
                prepend-icon="event"
                :class="{ 'datepicker--hide': !editing }"
                readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex>
              <v-textarea
                v-model="taskData.report_description"
                :readonly="!editing"
                label="Opis zgłoszenia"
              ></v-textarea>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="geometry-panel">
            <v-flex
              xs4
              v-if="!hasGeometry"
              :class="{ btnDisabled: !editing }"
              style="border-right: 1px solid lightgrey;line-height: 50px;display:flex;"
            >
              <v-icon
                class="table__btn--green geometry-panel__add-btn"
                @click="addGeometry"
                :class="{ btnDisabled: !editing }"
                >add_circle</v-icon
              >
              <p @click="addGeometry" class="hover__pointer">DODAJ GEOMETRIĘ</p>
            </v-flex>
            <v-flex
              xs4
              v-else
              style="border-right: 1px solid lightgrey;line-height: 50px;display:flex;"
              :class="{ btnDisabled: !editing }"
            >
              <v-icon
                :class="{ btnDisabled: !editing }"
                class="table__btn--red geometry-panel__delete-btn"
                @click="deleteGeometry"
                >delete</v-icon
              >
              <p class="hover__pointer" @click="deleteGeometry">
                USUŃ GEOMETRIĘ
              </p>
            </v-flex>
            <v-flex xs8>
              <v-layout justify-space-between id="geometry-panel">
                <p v-if="hasGeometry" class="msg--padding">GEOMETRIA DODANA</p>
                <p v-else class="msg--padding">BRAK DODANEJ GEOMETRII</p>
                <span v-if="hasGeometry">
                  <v-icon
                    title="Przybliż do geometrii"
                    class="geometry-panel__zoom-btn"
                    @click="zoomToGeom"
                    >zoom_in</v-icon
                  >
                </span>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-flex xs12>
            <v-subheader>OPIS LOKALIZACJI</v-subheader>
          </v-flex>
          <v-layout row wrap>
            <v-flex xs5>
              <v-text-field
                v-model="taskData.parcel"
                :readonly="!editing"
                label="Numer działki"
              ></v-text-field>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-text-field
                v-model="taskData.address"
                :readonly="!editing"
                label="Adres"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5>
              <v-select
                :items="localization_type"
                no-data-text="Brak typów lokalizacji"
                v-model="taskData.localization_type"
                :readonly="!editing"
                label="Typ lokalizacji"
                :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
              ></v-select>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-text-field
                v-model="taskData.localization_description"
                :readonly="!editing"
                label="Opis lokalizacji"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-subheader>ZGŁASZAJĄCY</v-subheader>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs5>
              <v-text-field
                v-model="taskData.reported_by_name"
                :readonly="!editing"
                label="Zgłaszający"
              ></v-text-field>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-text-field
                v-model="taskData.reported_by_address"
                :readonly="!editing"
                label="Adres"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5>
              <v-text-field
                v-model="taskData.reported_by_phone"
                :readonly="!editing"
                label="Telefon"
              ></v-text-field>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-text-field
                v-model="taskData.reported_by_email"
                :readonly="!editing"
                label="E-mail"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5>
              <v-menu
                v-model="reportedDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                :readonly="!editing"
              >
                <template :readonly="!editing" v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formattedReportedDate"
                    label="Data przyjęcia zgłoszenia"
                    prepend-icon="event"
                    :class="{ 'datepicker--hide': !editing }"
                    :readonly="!editing"
                    @input="
                      taskData.reported_at_datetime = parseDate(
                        formattedReportedDate
                      )
                    "
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="taskData.reported_at_datetime"
                  @input="reportedDateMenu = false"
                  color="#2a579a"
                  no-title
                  :readonly="!editing"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-spacer />
            <v-flex xs5 :class="{ 'datepicker--hide': !editing }">
              <v-menu
                ref="menuTimeReported"
                :close-on-content-click="false"
                v-model="menuTimeReported"
                :nudge-right="40"
                :return-value.sync="reportedTime"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="reportedTime"
                  :readonly="!editing"
                  prepend-icon="access_time"
                  hide-details
                  label="Godzina przyjęcia zgłoszenia"
                ></v-text-field>
                <v-time-picker
                  v-if="menuTimeReported"
                  format="24hr"
                  v-model="reportedTime"
                  full-width
                  @input="$refs.menuTimeReported.save(reportedTime)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5>
              <v-select
                :items="users"
                item-text="name"
                item-value="id"
                no-data-text="Brak użytkowników"
                v-model="taskData.reported_operator"
                :readonly="!editing"
                :rules="required"
                label="Przyjmujący zgłoszenie"
                :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-subheader>PRZYPISANIE EKIPY DO ZLECONEGO ZADANIA</v-subheader>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12>
              <v-select
                v-model="taskData.users"
                :items="users"
                item-text="name"
                item-value="id"
                :readonly="!editing"
                label="Przypisani pracownicy"
                multiple
                :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                chips
              ></v-select>
            </v-flex>
            <v-spacer />
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-textarea
                v-model="taskData.message"
                :readonly="!editing"
                label="Wiadomość do ekipy w terenie"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-form>
      </v-tab-item>
      <v-tab>
        PODSUMOWANIE
      </v-tab>
      <v-tab-item>
        <v-layout row wrap>
          <v-select
            :items="damage_type"
            no-data-text="Brak rodzajów uszkodzenia"
            v-model="taskData.damage_type"
            :readonly="!editing"
            label="Rodzaj uszkodzenia"
            :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
          ></v-select>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs5>
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              :readonly="!editing"
            >
              <template :readonly="!editing" v-slot:activator="{ on }">
                <v-text-field
                  v-model="formattedStartDate"
                  label="Data rozpoczęcia wykonywania zadania"
                  prepend-icon="event"
                  :class="{ 'datepicker--hide': !editing }"
                  :readonly="!editing"
                  @input="taskData.start_time = parseDate(formattedStartDate)"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="taskData.start_time"
                @input="startDateMenu = false"
                color="#2a579a"
                no-title
                :readonly="!editing"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-spacer />
          <v-flex xs5 :class="{ 'datepicker--hide': !editing }">
            <v-menu
              ref="startTimeMenu"
              :close-on-content-click="false"
              v-model="startTimeMenu"
              :nudge-right="40"
              :return-value.sync="startTime"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="startTime"
                :readonly="!editing"
                hide-details
                :class="{ 'datepicker--hide': !editing }"
                prepend-icon="access_time"
                label="Godzina rozpoczęcia wykonywania zadania"
              ></v-text-field>
              <v-time-picker
                v-if="startTimeMenu"
                format="24hr"
                v-model="startTime"
                full-width
                @input="$refs.startTimeMenu.save(startTime)"
              ></v-time-picker>
            </v-menu>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs5>
            <v-select
              :items="net_kind"
              no-data-text="Brak rodzajów sieci"
              v-model="taskData.net_kind"
              :readonly="!editing"
              label="Rodzaj sieci"
              :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
            ></v-select>
          </v-flex>
          <v-spacer />
          <v-flex xs5>
            <v-select
              :items="causes"
              no-data-text="Brak przyczyn"
              v-model="taskData.damage_causes"
              multiple
              :readonly="!editing"
              label="Przyczyny"
              :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex>
            <v-textarea
              v-model="taskData.description"
              :readonly="!editing"
              label="Opis zadania"
            ></v-textarea>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs5>
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              :readonly="!editing"
            >
              <template :readonly="!editing" v-slot:activator="{ on }">
                <v-text-field
                  v-model="formattedEndDate"
                  label="Data zakończenia wykonywania zadania"
                  prepend-icon="event"
                  :class="{ 'datepicker--hide': !editing }"
                  :readonly="!editing"
                  @input="taskData.start_time = parseDate(formattedEndDate)"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="taskData.end_time"
                @input="endDateMenu = false"
                color="#2a579a"
                no-title
                :readonly="!editing"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-spacer />
          <v-flex xs5 :class="{ 'datepicker--hide': !editing }">
            <v-menu
              ref="endTimeMenu"
              :close-on-content-click="false"
              v-model="endTimeMenu"
              :nudge-right="40"
              :return-value.sync="endTime"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="endTime"
                :readonly="!editing"
                prepend-icon="access_time"
                hide-details
                :class="{ 'datepicker--hide': !editing }"
                label="Godzina zakończenia wykonywania zadania"
              ></v-text-field>
              <v-time-picker
                v-if="endTimeMenu"
                format="24hr"
                v-model="endTime"
                full-width
                @input="$refs.endTimeMenu.save(endTime)"
              ></v-time-picker>
            </v-menu>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-subheader>PODSUMOWANIE UŻYTYCH MATERIAŁÓW</v-subheader>
          </v-flex>
        </v-layout>
        <template v-if="!isNewTask">
          <v-layout row wrap v-if="editing">
            <v-flex xs2>
              <v-select
                :items="material_type"
                no-data-text="Brak typów materiału"
                :return-object="true"
                item-text="value"
                v-model="material.material_type"
                :readonly="!editing"
                label="Typ materiału"
                :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
              >
              </v-select>
            </v-flex>
            <v-spacer />
            <v-flex xs2>
              <v-select
                :items="currentSubdict"
                no-data-text="Brak podtypów materiału"
                v-model="material.material_subtype"
                :readonly="!editing"
                label="Podtyp materiału"
                :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
              >
              </v-select>
            </v-flex>
            <v-spacer />
            <v-flex xs2>
              <v-select
                :items="diameter"
                no-data-text="Brak średnic"
                v-model="material.diameter"
                :readonly="!editing"
                label="Średnica"
                :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
              >
              </v-select>
            </v-flex>
            <v-spacer />
            <v-flex xs2>
              <v-text-field
                v-model="material.amount"
                :readonly="!editing"
                label="Ilość"
              >
              </v-text-field>
            </v-flex>
            <v-spacer />
            <v-flex xs2>
              <v-select
                :items="unit"
                no-data-text="Brak jednostek"
                v-model="material.unit"
                :readonly="!editing"
                label="Jednostka"
                :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
              >
              </v-select>
            </v-flex>
            <v-spacer />
            <v-flex class="btn__materials--wrapper">
              <v-icon
                class="table__btn--green btn--materials"
                title="Dodaj zużyte materiały"
                @click="addMaterial"
                v-show="!editingMaterial"
              >
                add_circle
              </v-icon>
              <v-icon
                class="table__btn--green btn--materials"
                title="Zapisz zmiany"
                @click="saveEditingMaterial"
                v-show="editingMaterial"
              >
                check_circle
              </v-icon>
              <v-icon
                class="table__btn--red btn--materials"
                title="Anuluj zmiany"
                @click="cancelEditingMaterial"
                v-show="editingMaterial"
              >
                cancel
              </v-icon>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-list class="profileList">
              <v-list-tile>
                <v-list-tile-title class="list--el--bold"
                  >Typ</v-list-tile-title
                >
                <v-list-tile-title class="border--left list--el--bold"
                  >Podtyp</v-list-tile-title
                >
                <v-list-tile-title class="border--left list--el--bold"
                  >Średnica</v-list-tile-title
                >
                <v-list-tile-title class="border--left list--el--bold"
                  >Ilość</v-list-tile-title
                >
                <v-list-tile-title class="border--left list--el--bold"
                  >Jednostka</v-list-tile-title
                >
                <v-list-tile-title
                  v-show="editing"
                  class="border--left list--el--bold"
                  >Opcje</v-list-tile-title
                >
              </v-list-tile>
              <template v-if="hasMaterials">
                <v-list-tile
                  :key="index"
                  v-for="(row, index) in taskData.materials"
                >
                  <v-list-tile-title>{{ row.material_type }}</v-list-tile-title>
                  <v-list-tile-title class="border--left">{{
                    row.material_subtype
                  }}</v-list-tile-title>
                  <v-list-tile-title class="border--left">{{
                    row.diameter
                  }}</v-list-tile-title>
                  <v-list-tile-title class="border--left">{{
                    row.amount
                  }}</v-list-tile-title>
                  <v-list-tile-title class="border--left">{{
                    row.unit
                  }}</v-list-tile-title>
                  <v-list-tile-title v-show="editing" class="border--left">
                    <span>
                      <v-icon
                        class="table__btn--orange geometry-panel__add-btn"
                        @click="startEditingMaterial(index)"
                      >
                        edit
                      </v-icon>
                      <v-icon
                        class="table__btn--red geometry-panel__add-btn"
                        @click="deleteMaterial(index)"
                      >
                        delete
                      </v-icon>
                    </span></v-list-tile-title
                  >
                </v-list-tile>
              </template>
              <template v-else>
                <v-list-tile class="list--el">
                  <v-list-tile-title
                    >Brak przypisanych zużytych materiałów</v-list-tile-title
                  >
                </v-list-tile>
              </template>
            </v-list>
          </v-layout>
        </template>
        <template v-else>
          <v-card-text class="msg--no-data">
            Przypisanie zużytych materiałów dostępne jest po zapisaniu
            zadania</v-card-text
          >
        </template>
      </v-tab-item>
      <!-- No events during adding insepction - that's why (0) -->
      <v-tab v-if="featureEvents != undefined"
        >ZDARZENIA ({{ featureEvents.events_count }})</v-tab
      >
      <v-tab v-else>ZDARZENIA (0)</v-tab>
      <v-tab-item>
        <template v-if="!isNewTask">
          <Events
            style="margin-top: 15px"
            :featureEvents="featureEvents"
            :objectType="module"
            :objectTable="module"
            :module="module"
            :id="taskData.id"
          />
        </template>
        <template v-else>
          <v-card-text class="msg--no-data"
            >Zdarzenia dostępne są po zapisaniu zadania</v-card-text
          >
        </template>
      </v-tab-item>
      <v-tab>ZAŁĄCZNIKI ({{ attachmentsArr.data.length }})</v-tab>
      <v-tab-item>
        <template v-if="!isNewTask">
          <v-layout row>
            <v-flex
              xs12
              v-if="
                $can('read', 'tasks_attachments') ||
                  $can('edit', 'tasks_attachments')
              "
            >
              <v-subheader class="font--primary"
                >Powiązane załączniki</v-subheader
              >
              <div v-if="ifAttachments.hasOwnProperty('data')">
                <li
                  class="list__container--el"
                  v-for="(index, key) in attachmentsArr.data"
                  :key="key"
                >
                  <span> {{ index.id }} - {{ index.filename }}</span>
                  <span>
                    <input
                      class="checkbox--photo"
                      type="checkbox"
                      :value="index.id"
                      v-model="choosenPhotos"
                      v-if="index.mimetypeKind === 'image'"
                      title="Dołącz zdjęcie do raportu"
                    />
                    <v-icon
                      @click="downloadAttachment(index.id, index.filename)"
                      small
                      title="Pobierz załącznik"
                      v-if="
                        $can('read', 'tasks_attachments') ||
                          $can('edit', 'tasks_attachments')
                      "
                      >cloud_download</v-icon
                    >
                    <v-icon
                      @click="deleteAttachment(index.id)"
                      small
                      title="Usuń załącznik"
                      v-if="$can('edit', 'tasks_attachments')"
                      >delete</v-icon
                    >
                  </span>
                </li>
              </div>
              <div v-else>
                <p class="font--primary">Brak powiązanych załączników</p>
              </div>
              <AddAttachment
                v-if="taskData.hasOwnProperty('id')"
                v-show="editing"
                ref="childComponent"
                @attachmentAdded="updateList()"
                @attachmentDeleted="updateList()"
                @confDialogOpened="triggerDialogAttach"
                :id_="numberID"
                :objectType="module"
                :objectTable="module"
                :auto="true"
                :module="module"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap v-show="editing">
            <v-subheader class="font--primary"
              >ZAŁĄCZNIKI Z BAZY DANYCH</v-subheader
            >
          </v-layout>
          <v-layout row wrap style="height: 90%" v-show="editing">
            <v-flex xs12>
              <DatabaseAttachments
                :objectIdCard="taskData.id"
                :objectTableCard="module"
                :objectTypeCard="module"
                @attachmentAdded="updateList"
              />
            </v-flex>
          </v-layout>
        </template>
        <template v-else>
          <v-card-text class="msg--no-data"
            >Dodawanie załączników jest dostępne po zapisaniu
            zadania</v-card-text
          >
        </template>
      </v-tab-item>
    </v-tabs>
  </Modal>
</template>

<script>
import AddAttachment from "../../../shared/AddAttachment";
import DatabaseAttachments from "../../table/attachments/DatabaseAttachments";
import Events from "../../../shared/Events";
import Modal from "../../../shared/Modal";

import isArray from "lodash/isArray";
import isObject from "lodash/isObject";

export default {
  components: {
    AddAttachment,
    DatabaseAttachments,
    Events,
    Modal
  },
  data: () => ({
    // Właściwości modala
    module: "tasks",
    // Zmienne sterujące komponentami
    createdDateMenu: false,
    reportedDateMenu: false,
    menuTimeReported: false,
    startDateMenu: false,
    startTimeMenu: false,
    endDateMenu: false,
    endTimeMenu: false,
    editing: false,
    editingMaterial: false,
    isNewTask: false,
    isSubdictReady: false,
    tempValue: {},
    // hasGeometry: false,
    // Dane ze słowników
    user: [],
    status: [],
    task_type: [],
    priority: [],
    net_type: [],
    localization_type: [],
    material_type: [],
    material_subtype: [],
    diameter: [],
    unit: [],
    damage_type: [],
    hydrant_kind: [],
    subDicts: {},
    net_kind: [],
    causes: [],
    // Dane obiektu
    attachmentsArr: {
      data: []
    },
    taskData: {
      materials: [],
      geometry: {}
    },
    taskDataCopy: {},
    reportedTime: undefined,
    formattedCreatedTime: undefined,
    formattedReportedDate: undefined,
    formattedStartDate: undefined,
    formattedEndDate: undefined,
    startTime: undefined,
    endTime: undefined,
    editedMaterialDataIndex: undefined,
    materialDataCopy: undefined,
    choosenPhotos: [],
    // Materiały
    material: {
      material_type: undefined,
      material_subtype: undefined,
      diameter: undefined,
      amount: undefined,
      unit: undefined
    },
    // Walidacja
    required: [v => !!v || "Pole wymagane"],
    valid: false
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    featureEvents() {
      return this.$store.getters.getFeatureEvents;
    },
    ifAttachments() {
      return this.$store.getters.getObjectAttachments;
    },
    cardTitle() {
      let title = "KARTA ZADANIA";
      if (this.taskData && this.taskData.id !== undefined)
        title += ` O ID ${this.taskData.id}`;
      return title;
    },
    users() {
      return this.$store.getters.getUsers.map(user => {
        return {
          name: user.name,
          id: user.id
        };
      });
    },
    numberID() {
      return parseInt(this.taskData.id);
    },
    hasMaterials() {
      if (this.taskData.materials) {
        return this.taskData.materials.length > 0;
      }
    },
    currentSubdict() {
      if (this.material.material_type) {
        return this.subDicts[this.material.material_type.subdict_id];
      }
    },
    hasGeometry() {
      return (
        this.taskData.geometry &&
        this.taskData.geometry.hasOwnProperty("coordinates")
      );
    }
  },
  watch: {
    "taskData.start_time"(val) {
      if (
        this.taskData.hasOwnProperty("start_time") &&
        val !== null &&
        val !== undefined
      ) {
        this.formattedStartDate = this.formatDate(
          this.taskData.start_time.slice(0, 10)
        );
      }
    },
    "taskData.end_time"(val) {
      if (
        this.taskData.hasOwnProperty("end_time") &&
        val !== null &&
        val !== undefined
      ) {
        this.formattedEndDate = this.formatDate(
          this.taskData.end_time.slice(0, 10)
        );
      }
    },
    "taskData.created_time"(val) {
      if (
        this.taskData.hasOwnProperty("created_time") &&
        val !== null &&
        val !== undefined
      ) {
        this.formattedCreatedTime = this.formatDate(
          this.taskData.created_time.slice(0, 10)
        );
      }
    },
    "taskData.reported_at_datetime"(val) {
      if (
        this.taskData.hasOwnProperty("reported_at_datetime") &&
        this.taskData.reported_at_datetime !== null &&
        this.taskData.reported_at_datetime !== undefined
      ) {
        this.formattedReportedDate = this.formatDate(
          this.taskData.reported_at_datetime.slice(0, 10)
        );
      }
    }
    // 'material.material_type'(val) {
    //   this.currentSubdict = this.subDicts[val.subdict_id]
    // }
    // 'material.material_type'(val) {
    //   console.log('a')
    //   if(val) {
    //     this.subDicts[val.subdict_id].forEach(dictValue => {
    //       // this.tempValue = {}
    //       // this.$set(this.tempValue, 'value', dictValue)
    //       // this.$set(this.tempValue, 'displayed', dictValue.length > 12 ? `${dictValue.slice(0, 8)}...` : dictValue)
    //       // this.$set(this.currentSubdict, this.currentSubdict.length, this.tempValue)
    //       // console.log(this.currentSubdict)
    //       // console.log(this.tempValue)

    //       return {
    //         value: dictValue,
    //         displayed: dictValue.length > 12 ? `${dictValue.slice(0, 8)}...` : dictValue
    //       }

    //     })
    //     setTimeout(() => {
    //       this.isSubdictReady = true
    //     }, 1000)
    //   }
    // }
    // 'taskData.geometry'(val) {
    //   console.log(val)
    //   if(val && val.hasOwnProperty('coordinates')) {
    //     this.hasGeometry = true
    //   } else {
    //     this.hasGeometry = false
    //   }
    // }
  },
  methods: {
    addGeometry() {
      this.$root.$emit(
        "showSnackbar",
        "#2a579a",
        "Kliknij na mapie, aby narysować obszar"
      );
      this.$root.$emit("addNewArea", this.module);
      this.isDrawing = true;
    },
    addMaterial() {
      const material_copy = Object.assign({}, this.material);
      delete material_copy.task;
      material_copy.material_type = material_copy.material_type.value;
      material_copy.task = this.taskData.id;
      this.$store.dispatch("addTaskMaterials", material_copy).then(r => {
        if (r.status === 201) {
          material_copy.id = r.data.created;
          this.$set(
            this.taskData.materials,
            this.taskData.materials.length,
            material_copy
          );
          this.material = {};
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas dodawania zużytych materiałów wystąpił błąd"
          );
        }
      });
    },
    addNewTask() {
      let open = () => {
        this.show("taskCardModal");
        this.isNewTask = true;
        this.editing = true;
        this.taskData.reported_operator = this.$store.state.user.id;
      };
      if (this.activeModals.includes("taskCardModal")) {
        this.$modal.hide("taskCardModal");
        setTimeout(() => open, 200);
      } else {
        open();
      }
    },
    assignGeomToTask(polygonData) {
      this.taskData.geometry = polygonData[0];
    },
    cancelEditing() {
      this.editing = false;
      this.taskData = Object.assign({}, this.taskDataCopy);
    },
    cancelEditingMaterial() {
      this.editingMaterial = false;
      this.material = {};
    },
    closed() {
      this.$store.commit("setFeatureEvents", undefined);
      this.taskData = {};
      this.editing = false;
      this.editingMaterial = false;
      this.isNewTask = false;
      this.deleteGeometry();
      this.attachmentsArr = {
        data: []
      };
      this.formattedCreatedTime = undefined;
      this.formattedEndDate = undefined;
      this.formattedStartDate = undefined;
      this.formattedReportedDate = undefined;
      this.endTime = undefined;
      this.startTime = undefined;
      this.reportedTime = undefined;
      this.choosenPhotos = [];
    },
    deleteAttachment(attachmentId) {
      this.choosenPhotos.splice(this.choosenPhotos.indexOf(attachmentId), 1);
      this.$refs.childComponent.deleteAttachment(attachmentId);
    },
    deleteGeometry() {
      this.$root.$emit("removeMapLayer");
      this.$set(this.taskData, "geometry", {});
    },
    deleteMaterial(index) {
      this.$emit("confDialogOpened", true);
      this.$modal.show("dialog", {
        title: "Usuwanie zadania",
        text: "Czy na pewno chcesz usunąć zadanie?",
        buttons: [
          {
            title: "NIE",
            handler: () => {
              this.$emit("confDialogOpened", false);
              this.$modal.hide("dialog");
              return;
            }
          },
          {
            title: "TAK",
            default: true,
            handler: () => {
              this.$store
                .dispatch(
                  "deleteTaskMaterials",
                  this.taskData.materials[index].id
                )
                .then(r => {
                  if (r.status === 200) {
                    this.taskData.materials.splice(index, 1);
                  } else {
                    this.$root.$emit(
                      "showSnackbar",
                      "red",
                      "Podczas usuwania wystąpił błąd"
                    );
                  }
                });
              this.$emit("confDialogOpened", false);
              this.$modal.hide("dialog");
            }
          }
        ]
      });
    },
    downloadAttachment(attachmentId, attachmentName) {
      this.$refs.childComponent.downloadAttachment(
        attachmentId,
        attachmentName
      );
    },
    getDicts() {
      const fieldsTasks = [
        "status",
        "task_type",
        "priority",
        "net_type",
        "localization_type",
        "damage_type",
        "net_kind"
      ];
      const fieldsMaterials = [
        "diameter",
        "unit",
        "material_subtype",
        "material_type"
      ];
      const fieldsHydrants = ["hydrant_kind"];
      const fieldsPumps = ["pump_kind"];
      fieldsTasks.forEach(field => {
        this.getDictValues(field);
      });
      fieldsMaterials.forEach(field => {
        if (field !== "material_type") {
          this.getDictValues(field, "tasks_materials");
        } else {
          this.getDictValues(field, "tasks_materials", "registry", true);
        }
      });
      fieldsHydrants.forEach(field => {
        this.getDictValues(field, "hydrants", "aquagis");
      });
      fieldsPumps.forEach(field => {
        this.getDictValues(field, "pumps", "aquagis");
      });
      this.$store
        .dispatch("getDictSTC", {
          schema: "registry",
          table: "tasks_damage_causes",
          column: "value"
        })
        .then(r => {
          this.causes = r.values;
        });
    },
    getDictValues(
      field,
      table = "tasks",
      schema = "registry",
      withSubdicts = false
    ) {
      let payload = {
        schema: schema,
        table: table,
        column: field,
        "with-subdicts": withSubdicts
      };
      this.$store.dispatch("getDictSTC", payload).then(r => {
        if (!r) {
          return;
        } else {
          this[field] = r.values;
          if (field === "material_type") {
            r.values.forEach(value => {
              this.$store
                .dispatch("getSingleDict", value.subdict_id)
                .then(dict => {
                  this.subDicts[dict.id] = dict.values;
                });
            });
          }
        }
      });
    },
    getUsers() {
      this.$store.dispatch("getUsers");
    },
    loadData(data) {
      this.isNewTask = false;
      this.editing = false;
      this.taskData = Object.assign({}, data);
      //fixowanie użytkowników z obiektu do id
      if (data.users) {
        this.taskData.users = this.taskData.users.map(v => v.id);
      }
      let payload = {
        object_id: data.id,
        object_type: "layers",
        events_count: true,
        objet_table: "tasks",
        limit: 5
      };
      if (
        this.taskData.hasOwnProperty("reported_at_datetime") &&
        this.taskData.reported_at_datetime !== null &&
        this.taskData.reported_at_datetime !== undefined
      ) {
        this.reportedTime = this.taskData.reported_at_datetime.slice(11, 16);
        this.taskData.reported_at_datetime = this.taskData.reported_at_datetime.slice(
          0,
          10
        );
      }
      if (
        this.taskData.hasOwnProperty("start_time") &&
        this.taskData.start_time !== null &&
        this.taskData.start_time !== undefined
      ) {
        this.startTime = this.taskData.start_time.slice(11, 16);
        this.taskData.start_time = this.taskData.start_time.slice(0, 10);
      }
      if (
        this.taskData.hasOwnProperty("end_time") &&
        this.taskData.end_time !== null &&
        this.taskData.end_time !== undefined
      ) {
        this.endTime = this.taskData.end_time.slice(11, 16);
        this.taskData.end_time = this.taskData.end_time.slice(0, 10);
      }

      if (data.geometry) {
        this.$root.$emit("zoomToArea", [data.geometry.coordinates]);
        this.$root.$emit(
          "addMapLayer",
          [data.geometry, data.geometry.coordinates],
          "tasks"
        );
      }
    },
    triggerDialogAttach(val) {
      this.$emit("confDialogOpened", val);
    },
    updateList() {
      if (this.taskData && this.taskData.id) {
        let payload = {
          object_type: this.module,
          layer: this.module,
          oid: this.taskData.id
        };
        this.$store
          .dispatch("getAttachmentsForObject", payload)
          .then(success => {
            if (success) {
              this.attachmentsArr.data = this.$store.getters.getObjectAttachments.data.map(
                att => {
                  att.mimetypeKind = att.mimetype.split("/")[0];
                  return att;
                }
              );
            }
          });
      }
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("-");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    },
    preparePayload() {
      const timeProperties = ["end_time", "reported_at_datetime", "start_time"];
      const payload = Object.assign({}, this.taskData);
      if (payload.materials) {
        delete payload.materials;
      }
      timeProperties.forEach(prop => {
        if (payload[prop]) {
          if (this[prop.split("_")[0] + "Time"]) {
            payload[prop] += `T${this[prop.split("_")[0] + "Time"]}:00`;
          } else {
            payload[prop] += "T00:00:00";
          }
        }
      });
      let operator = payload.reported_operator.id;
      delete payload.operator;
      payload["reported_operator"] = operator;
      return payload;
    },
    printReport() {
      this.$root.$emit("printReport", [
        "task",
        this.taskData.id,
        this.choosenPhotos
      ]);
    },
    saveEditing() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("editTask", this.preparePayload()).then(r => {
          if (r.status === 200) {
            this.editing = false;
            this.$root.$emit("updateTaskTable");
            this.$root.$emit("setTaskColor", this.taskData);
          } else {
            this.$root.$emit(
              "showSnackbar",
              "red",
              "Podczas edytowania danych przyłącza wystąpił błąd"
            );
          }
        });
      }
    },
    saveEditingMaterial() {
      const material_copy = Object.assign({}, this.material);
      delete material_copy.task;
      material_copy.material_type = material_copy.material_type.value;
      let payload = {
        oid: this.material.id,
        body: material_copy
      };
      if (this.hasGeometry) {
        this.$store.dispatch("editTaskMaterials", payload).then(r => {
          if (r.status === 200) {
            this.$set(
              this.taskData.materials,
              [this.editedMaterialDataIndex],
              material_copy
            );
            this.editingMaterial = false;
            this.material = {};
          } else {
            this.$root.$emit(
              "showSnackbar",
              "red",
              "Podczas edytowania danych zużytego materiału wystąpił błąd"
            );
          }
        });
      } else {
        this.$root.$emit(
          "showSnackbar",
          "red",
          "Geometria zadania jest wymagana"
        );
      }
    },
    saveTask() {
      if (this.$refs.form.validate()) {
        if (this.hasGeometry) {
          this.$store.dispatch("addTask", this.preparePayload()).then(r => {
            if (r.status === 201) {
              this.$modal.hide("taskCardModal");
              this.$root.$emit("updateTaskTable");
              this.$root.$emit(
                "showSnackbar",
                "success",
                `Pomyślnie dodano zadanie o ID: ${r.data.inserted}`
              );
            } else {
              this.$root.$emit(
                "showSnackbar",
                "red",
                "Podczas dodawania zadania wystąpił błąd"
              );
            }
          });
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Geometria zadania jest wymagana"
          );
        }
      }
    },
    show(title) {
      if (this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    startEditing() {
      this.editing = true;
      this.taskDataCopy = Object.assign({}, this.taskData);
    },
    startEditingMaterial(index) {
      this.editingMaterial = true;
      this.editedMaterialDataIndex = index;
      let materialType = this.material_type.find(dictValue => {
        return dictValue.value === this.taskData.materials[index].material_type;
      });
      this.material = Object.assign({}, this.taskData.materials[index]);
      this.material.material_type = materialType;
    },
    formatDate(date) {
      if (!date) {
        return null;
      } else {
        const [year, month, day] = date.split("-");
        return `${day}.${month}.${year}`;
      }
    },

    zoomToGeom() {
      this.$root.$emit("zoomToArea", [this.taskData.geometry.coordinates]);
    }
  },
  mounted() {
    this.$root.$on("deletedAttachmentGlobal", this.updateList);
    this.$root.$on("loadTaskData", this.loadData);
    this.$root.$on("newGeomAdded", this.assignGeomToTask);
    this.$root.$on("addNewTask", this.addNewTask);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/tasks/modals/TaskCard.vue